export const NoResults = ({ message }: { message?: string }) => (
  <div className="flex h-full flex-col items-center justify-center text-center">
    <h3 className="text-sm text-tiga-text-default">{message}</h3>
  </div>
);
